export default __webpack_public_path__ + "static/media/menu_link_user_not_selected.46f50860.svg";